<template>
  <v-card-text>
    <v-data-iterator :items="popUps" :items-per-page="10" :page="1">
      <template v-slot:default="props">
        <v-row>
          <v-col
            v-for="item in props.items"
            :key="item.id"
            cols="12"
            lg="4"
            md="6"
            sm="12"
          >
            <CardPopUp
              :item="item"
              :srcImage="loadImage(item.img_popups)"
              @edit="$emit('edit', item)"
              @remove="$emit('remove', item)"
            ></CardPopUp>
          </v-col>
        </v-row>
      </template>
    </v-data-iterator>
  </v-card-text>
</template>

<script>
import CardPopUp from "@/components/cards/CardPopUp.vue";
import { loadAPIImage } from "@/utils/images";
export default {
  components: {
    CardPopUp,
  },
  props: {
    popUps: Array,
  },
  methods: {
    loadImage(src) {
      return loadAPIImage(src);
    },
  },
};
</script>

<style lang="scss" scoped></style>
